import { Link } from 'react-router-dom';
import type { Drama } from '@/types/drama';

interface DramaCardProps {
  drama: Drama;
  index?: number;
}

export default function DramaCard({ drama, index = 0 }: DramaCardProps) {
  return (
    <Link
      to={`/detail/${drama.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-all duration-300 animate-fade-up cursor-pointer"
      style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={drama.cover}
          alt={`${drama.title}海报`}
          title={`${drama.title} - 香草视频 免费在线观看高清电视剧`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-medium bg-accent-500 text-background-50">
          {drama.status}
        </span>
        <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md text-[11px] font-medium bg-background-50/90 text-foreground-800">
          {drama.year}
        </span>
        <span className="absolute bottom-3 left-3 right-3 hidden group-hover:flex items-center justify-center gap-1 text-xs font-medium text-background-50">
          <i className="ri-play-circle-line text-lg" />
          查看详情
        </span>
      </div>
      <div className="p-3 md:p-3.5">
        <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 truncate group-hover:text-primary-700 transition-colors">
          {drama.title}
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-1.5">
          {drama.types.slice(0, 2).map((type) => (
            <span key={type} className="px-1.5 py-0.5 rounded text-[11px] bg-secondary-100 text-secondary-900">
              {type}
            </span>
          ))}
        </div>
        <p className="mt-2 text-xs text-foreground-500 truncate">
          {drama.status === '已完结'
            ? `全 ${drama.totalEpisodes} 集`
            : `更新至第 ${drama.currentEpisodes} 集`}
          <span className="mx-1.5 text-background-300">|</span>
          {drama.region}
        </p>
      </div>
    </Link>
  );
}